import { render, staticRenderFns } from "./ModalSubmittals.vue?vue&type=template&id=5c0d50f9&lang=pug&"
import script from "./ModalSubmittals.vue?vue&type=script&lang=js&"
export * from "./ModalSubmittals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports